import {Input} from "antd";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../app/store";
import {setGlobalFilter} from "../../app/store/reducers/appSlice";
import {GlobalSearchContainer, FilterButton} from "./styles";
import { useDebounce } from "@uidotdev/usehooks";
import ResetButton from "../reset-button/index";


export default function GlobalSearch() {
    const timerId = useRef(-1)
    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const filter = useAppSelector(store => store.AppSlice.filter)

    const [searchValue, setSearchValue] = useState("")

    const submitSearch = () => {
        dispatch(setGlobalFilter(searchValue))
    }

    const handleChange = (evt:any) => {
        clearTimeout(timerId.current)
        setSearchValue(evt.target.value);


        const id: any = setTimeout(() => {
            dispatch(setGlobalFilter(evt.target.value))
        }, 750)

        timerId.current = id
    }

    useEffect(() => {
        setSearchValue(filter.seo)
    }, [filter.seo])

    return (
        <GlobalSearchContainer>
            <Input
                allowClear={true}
                placeholder={t("GlobalSearchPlaceholder") as string}
                value={searchValue}
                onChange={handleChange}
            />
            <FilterButton
                //className="page-head__btn btn btn--primary btn--fill"
                children={t("Find")}
                onClick={submitSearch}
            />
            <ResetButton
                onClick={() => {
                    setSearchValue(""); // Очищаем локальное состояние поиска
                }}
            />
        </GlobalSearchContainer>
    )
}